<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    ></BlockUI>

    <v-card>
      <v-card-title class="title font-weight-medium">
        Fã Clube UseCar
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="my-2">
          <v-row justify="space-between">
            <v-flex xs12 md2 sm6>
              <v-col align="start">
                <vuetify-money
                  v-model="progressiveOffer.min_limit"
                  label="Valor inicial"
                  :options="options"
                  :properties="properties"
                  required
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md2 sm6>
              <v-col align="start">
                <vuetify-money
                  v-model="progressiveOffer.max_limit"
                  label="Valor final"
                  :options="options"
                  :properties="properties"
                  required
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md2 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="progressiveOffer.discount"
                  v-mask="'####'"
                  label="Desconto"
                  required
                  prepend-icon="mdi-percent"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-select
                  label="Clientes não contemplados"
                  v-model="progressiveOffer.clients"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  required
                  multiple
                  prepend-icon="mdi-account-multiple"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.name }}</span>

                    <span v-if="index === 1" class="grey--text">
                      &nbsp;&nbsp; (+{{ progressiveOffer.clients.length - 1 }}
                      outros)
                    </span>
                  </template>

                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="selectClient"
                    >
                      <v-list-item-action>
                        <v-icon
                          :color="
                            progressiveOffer.clients.length > 0
                              ? 'indigo darken-4'
                              : ''
                          "
                        >
                          {{ iconInSelect }}
                        </v-icon>
                      </v-list-item-action>

                      <v-list-item-content>
                        Selecionar todos
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-flex>

            <v-flex xs12 md2 sm6>
              <v-col align="center">
                <v-btn
                  block
                  class="mt-4 white--text"
                  :color="updateButton ? 'info' : 'success'"
                  @click="createOrUpdateOffer()"
                >
                  {{ updateButton ? 'Atualizar' : 'Cadastrar' }}
                </v-btn>
                <v-btn
                  v-show="updateButton"
                  block
                  class="mt-4"
                  color="error"
                  @click="clearFields()"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-flex class="mx-3 my-2" xs12 md12>
          <v-row justify="start">
            <v-col align="start">
              <v-tabs v-model="currentTab">
                <v-tab>Ativas</v-tab>
                <v-tab>Inativas</v-tab>
                <v-tab>Todas</v-tab>

                <v-tab-item v-model="currentTab">
                  <v-data-table
                    class="elevation-1 mt-2"
                    :headers="headers"
                    :items="filteredProgressiveOffers"
                    :footer-props="{
                      'items-per-page-text': 'Linhas por página:',
                      'items-per-page-options': [10, 15, 30, 50, 100],
                    }"
                    no-data-text="Nenhum desconto cadastrado"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>{{ item.min_limit | formatMoney }}</td>
                        <td>{{ item.max_limit | formatMoney }}</td>
                        <td>{{ item.discount }}</td>
                        <td>
                          {{ item.clients.length }}
                        </td>
                        <td>
                          <ActionButton
                            message="Ver clientes não contemplados"
                            icon="mdi-account-multiple"
                            color="info"
                            @onclick="
                              formatClientNamesAndUsers(item);
                              updateOfferClientsModal = true;
                            "
                          />

                          <ActionButton
                            :message="
                              item.status
                                ? 'Desativar desconto'
                                : 'Ativar desconto'
                            "
                            :icon="
                              item.status
                                ? 'mdi-power'
                                : 'mdi-play-circle-outline'
                            "
                            :color="item.status ? 'warning' : 'success'"
                            @onclick="
                              updateOfferStatusModal = true;
                              offer = item;
                            "
                          />

                          <ActionButton
                            message="Editar desconto"
                            icon="edit"
                            @onclick="setProgressiveOfferToEdit(item)"
                          />

                          <ActionButton
                            message="Excluir desconto"
                            icon="delete"
                            color="error"
                            @onclick="hardDeleteOffer(item)"
                          />
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>

    <!-- UPDATE OFFER STATUS -->
    <v-dialog v-model="updateOfferStatusModal" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 text-primary" color="">
          Tem certeza que deseja
          {{ this.offer.status ? 'desativar' : 'ativar' }} ?
        </v-card-title>

        <v-card-text>
          {{ this.offer.status ? 'Desativando' : 'Ativando' }} esse desconto,
          todos os clientes relacionados
          {{ this.offer.status ? 'não terão mais ' : 'terão' }} seus descontos
          aplicados.
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1 text-white"
            @click="updateOfferStatusModal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            :color="this.offer.status ? 'error darken-1' : 'success darken-1'"
            @click="updateOfferStatus"
          >
            {{ this.offer.status ? 'Desativar' : 'Ativar' }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CLIENT LIST MODAL -->
    <v-dialog v-model="updateOfferClientsModal" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 text-primary" color="">
          Clientes não contemplados
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="clientsHeaders"
            :items="clientsWithNamesAndUsers"
            :items-per-page="10"
            class="elevation-0"
            :footer-props="{
              'items-per-page-text': 'Linhas por página:',
              'items-per-page-options': [10, 15, 30, 50, 100],
            }"
            no-data-text="Nenhum cliente cadastrado"
          ></v-data-table>
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1 text-white"
            @click="updateOfferClientsModal = false"
          >
            Fechar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import ClientController from '../../controllers/ClientController';
import FanClubController from '../../controllers/FanClubController';
import UserController from '../../controllers/UserController';

export default {
  components: {
    ActionButton,
  },

  data() {
    return {
      fanClubController: new FanClubController(this.$resource),
      clientController: new ClientController(this.$resource),
      userController: new UserController(this.$resource),

      currentTab: 0,
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,

      search: '',

      headers: [
        { text: 'Valor inicial (R$)', value: 'min_limit' },
        { text: 'Valor final (R$)', value: 'max_limit' },
        { text: 'Desconto (%)', value: 'discount' },
        { text: 'Nº de clientes não contemplados', value: 'clients' },
        { text: 'Ações', value: 'action', sortable: false },
      ],

      clientsHeaders: [
        {
          text: 'Cliente',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Quantidade de usuários',
          value: 'users_amount',
          align: 'center',
          sortable: false,
        },
      ],

      offer: {},
      updateOfferStatusModal: false,
      updateOfferClientsModal: false,

      progressiveOffer: {
        id: null,
        min_limit: null,
        max_limit: null,
        discount: null,
        clients: [],
      },

      progressiveOffers: [],
      clientsExceptions: [],
      clientsWithNamesAndUsers: [],

      clients: [],

      options: {
        locale: 'pt-BR',
        length: 8,
        precision: 2,
      },
      properties: {
        'prepend-icon': 'mdi-currency-brl',
      },
    };
  },

  computed: {
    // Items filtrados de acordo com as abas
    filteredProgressiveOffers() {
      // Ativas
      if (this.currentTab == 0)
        return this.progressiveOffers.filter(offer => offer.status === true);
      // Inativas
      else if (this.currentTab == 1)
        return this.progressiveOffers.filter(offer => offer.status === false);
      // Todas
      else return this.progressiveOffers;
    },

    updateButton() {
      return this.progressiveOffer.id != null ? true : false;
    },

    // Variáveis relacionadas ao select de clients
    selectAllClients() {
      return this.progressiveOffer.clients.length === this.clients.length;
    },

    selectAnClient() {
      return this.progressiveOffer.clients.length > 0 && !this.selectAllClients;
    },

    iconInSelect() {
      if (this.selectAllClients) return 'mdi-close-box';
      if (this.selectAnClient) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },

  created() {
    this.getAllClients();
    this.getAllOffers();
  },

  methods: {
    selectClient() {
      this.$nextTick(() => {
        if (this.selectAllClients) {
          this.progressiveOffer.clients = [];
        } else {
          this.progressiveOffer.clients = this.clients.slice();
        }
      });
    },

    async getAllClients() {
      try {
        this.clients = [];
        this.clients = await this.clientController.getAllClients();
      } catch (error) {
        this.$awn.alert('Erro ao recuperar clientes.');
      }
    },

    async getAllClientsExceptions() {
      try {
        this.clientsExceptions = await this.fanClubController.getExceptions();
      } catch (error) {
        this.$awn.alert('Erro ao recuperar clientes não contemplados.');
      }
    },

    // Client with names and number of users
    async formatClientNamesAndUsers(offer) {
      this.clientsWithNamesAndUsers = [];

      for (const clientId of offer.clients) {
        let client = this.clients.find(clt => clt.id == clientId);
        let users = await this.userController.getUsersActiveByClientId(
          client.id
        );

        let formattedException = {
          name: client.name,
          users_amount: users.length,
        };

        this.clientsWithNamesAndUsers.push(formattedException);
      }
    },

    async getAllOffers() {
      try {
        // Recupera primeiro os clientes para concatenar os objetos
        await this.getAllClientsExceptions();

        let offers = await this.fanClubController.getAll();
        offers.forEach(offer => (offer.clients = []));

        // Acrescenta o array de clientes a uma oferta
        for (let offer of offers) {
          let exceptions = this.clientsExceptions.filter(
            exception => exception.discount_configuration_id == offer.id
          );

          for (let exception of exceptions) {
            offer.clients.push(exception.client_id);
          }
        }

        this.progressiveOffers = offers;
        this.$forceUpdate();
      } catch (error) {
        console.log(error);
        this.$awn.alert('Erro ao recuperar descontos.');
      }
    },

    async createOrUpdateOffer() {
      if (
        !Boolean(this.progressiveOffer.min_limit) ||
        !Boolean(this.progressiveOffer.max_limit) ||
        !Boolean(this.progressiveOffer.discount) ||
        this.progressiveOffer.clients.length == 0
      ) {
        this.$awn.alert('Preencha todos os campos corretamente.');
        return;
      }

      if (
        parseFloat(this.progressiveOffer.min_limit) >=
        parseFloat(this.progressiveOffer.max_limit)
      ) {
        this.$awn.alert('O valor inicial deve ser menor do que o valor final.');
        return;
      }

      // remove money mask
      this.progressiveOffer.min_limit = this.progressiveOffer.min_limit * 100;
      this.progressiveOffer.max_limit = this.progressiveOffer.max_limit * 100;

      // reduce client object
      this.progressiveOffer.clients = this.progressiveOffer.clients.map(
        client => (Number.isInteger(client) ? client : client.id)
      );

      Boolean(this.progressiveOffer.id)
        ? await this.updateOffer()
        : await this.createOffer();

      this.clearFields();
      await this.getAllOffers();
    },

    async createOffer() {
      try {
        await this.fanClubController.create(this.progressiveOffer);
        this.$awn.success('Desconto cadastrado com sucesso.');
      } catch (error) {
        this.$awn.alert('Erro ao cadastrar desconto progressivo.');
      }
    },

    setProgressiveOfferToEdit(offer) {
      this.progressiveOffer = Object.assign({}, this.progressiveOffer, offer);
      this.progressiveOffer.min_limit = this.progressiveOffer.min_limit / 100;
      this.progressiveOffer.max_limit = this.progressiveOffer.max_limit / 100;
    },

    async updateOffer() {
      try {
        await this.fanClubController.update(this.progressiveOffer);
        this.$awn.success('Desconto atualizado com sucesso.');
      } catch (error) {
        console.log(error);
        this.$awn.alert('Erro ao atualizar desconto progressivo.');
      }
    },

    async updateOfferStatus() {
      this.updateOfferStatusModal = false;

      try {
        this.offer.status = !this.offer.status;
        await this.fanClubController.update(this.offer);

        let message = this.offer.status ? 'ativado' : 'desativado';
        this.$awn.success(`Desconto ${message} com sucesso.`);
      } catch (error) {
        let message = this.offer.status ? 'ativar' : 'desativar';
        this.$awn.success(`Erro ao ${message} desconto.`);
      }
    },

    async hardDeleteOffer(progressiveOffer) {
      try {
        await this.fanClubController.delete(progressiveOffer.id);
        this.$awn.success('Desconto excluído com sucesso.');
        this.getAllOffers();
      } catch (error) {
        this.$awn.alert('Erro ao excluir desconto progressivo.');
      }
    },

    clearFields() {
      this.progressiveOffer = {
        min_limit: null,
        max_limit: null,
        discount: null,
        clients: [],
      };
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },

    formatMoney(value) {
      value = (value / 100).toFixed(2).replace('.', ',');
      return value;
    },
  },
};
</script>
